var FormatterDataTypeEnum = /* @__PURE__ */ ((FormatterDataTypeEnum2) => {
  FormatterDataTypeEnum2["City"] = "city";
  FormatterDataTypeEnum2["Dealership"] = "dealership";
  FormatterDataTypeEnum2["FilterValues"] = "filterValues";
  FormatterDataTypeEnum2["OptionGroup"] = "optionGroup";
  FormatterDataTypeEnum2["Specification"] = "specification";
  FormatterDataTypeEnum2["SpecificationGroup"] = "specificationGroup";
  FormatterDataTypeEnum2["Vehicle"] = "vehicle";
  return FormatterDataTypeEnum2;
})(FormatterDataTypeEnum || {});
export {
  FormatterDataTypeEnum
};
